import { render, staticRenderFns } from "./buyerOrderHistory.vue?vue&type=template&id=0f40da51&scoped=true&"
import script from "./buyerOrderHistory.vue?vue&type=script&lang=js&"
export * from "./buyerOrderHistory.vue?vue&type=script&lang=js&"
import style0 from "./buyerOrderHistory.vue?vue&type=style&index=0&id=0f40da51&prod&lang=less&scoped=true&"
import style1 from "./buyerOrderHistory.vue?vue&type=style&index=1&id=0f40da51&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f40da51",
  null
  
)

export default component.exports